routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.pqrsDetail', {
      url: __env.routes.pqrsDetail,
      template: `<pqrs-detail sh-ctrl="shCtrl"></pqrs-detail>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/pqrs/pqrs-detail/pqrs-detail.config.js